import React, { useState } from 'react'
import { navigate } from 'gatsby'

export default function CustomerCareButton() {
	const [showButton, setShowButton] = useState(true)

	return (
		<div className="fixed right-6 bottom-6 z-50 cursor-pointer">
			<button onClick={() => navigate('/contact-us')} className={`flex h-16 w-16 items-center justify-center rounded-full bg-ab-100 ${showButton ? 'block' : 'hidden'}`}>
				<span className="text-3xl font-semibold text-white">?</span>
			</button>
			<button
				className={`absolute top-0 -right-2 h-6 w-6 items-center justify-center rounded-full border bg-white text-sm ${showButton ? 'flex' : 'hidden'}`}
				onClick={() => setShowButton(false)}
			>
				x
			</button>
		</div>
	)
}
